import React from 'react';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Label } from './ui/label';

export const RatingGroup = ({ value, onChange, questionId, label }) => {
  const ratings = [1, 2, 3, 4, 5];
  
  return (
    <div className="space-y-3" data-testid={`rating-group-${questionId}`}>
      {label && (
        <Label className="text-base font-normal text-foreground">{label}</Label>
      )}
      <RadioGroup
        value={value?.toString()}
        onValueChange={(val) => onChange(parseInt(val))}
        className="flex items-center gap-3"
      >
        {ratings.map((rating) => (
          <div key={rating} className="flex items-center">
            <RadioGroupItem
              value={rating.toString()}
              id={`${questionId}-${rating}`}
              data-testid={`rating-${questionId}-option-${rating}`}
              className="h-10 w-10 border-2 border-primary data-[state=checked]:bg-primary data-[state=checked]:text-white hover:border-primary hover:scale-105 transition-transform"
            />
            <Label
              htmlFor={`${questionId}-${rating}`}
              className="ml-1.5 text-sm font-medium cursor-pointer"
            >
              {rating}
            </Label>
          </div>
        ))}
      </RadioGroup>
      <div className="flex justify-between text-xs text-muted-foreground mt-2">
        <span>Never True</span>
        <span>Always True</span>
      </div>
    </div>
  );
};